module.exports = __webpack_public_path__ + "static/media/bars-white.b75b4253.svg";